import { formatCurrency } from '@/lib/format.js';
import { usePeekStore } from '@/stores/peek-store.js';
import { openCarrierPeek } from '@/lib/links.js';

// Shape: account.service.js#getAccountStats →
//   { lifetime_premium, current_premium, retention_years,
//     earliest_bound_start, bound_term_count, carriers_used: [],
//     trust_balance, trust_last_reconciled_at }
export default function StatsSummaryCard({ stats }) {
  const openPeek = usePeekStore((s) => s.openPeek);
  if (!stats) return null;
  const tiles = [
    { label: 'Current term', value: formatCurrency(stats.current_premium) },
    { label: 'Lifetime premium', value: formatCurrency(stats.lifetime_premium) },
    {
      label: 'Retention',
      value: stats.retention_years ? `${stats.retention_years} yr` : '—',
    },
    {
      label: 'Trust balance',
      // A null balance is a failed read, not $0; a provisional one carries a
      // settled leg with no amount and says so (TRACON-MONEY-SPEC V6).
      value: stats.trust_balance == null
        ? 'not available'
        : `${formatCurrency(stats.trust_balance)}${stats.trust_balance_provisional ? ' (provisional)' : ''}`,
      muted: !stats.trust_balance || stats.trust_balance === 0,
    },
  ];
  const currentEntry = stats.carriers_used?.find((c) => c.is_current);
  return (
    <section className="rounded-card border border-border bg-surface p-4">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {tiles.map(({ label, value, muted }) => (
          <div key={label}>
            <div className="text-[10px] font-medium uppercase tracking-wider text-text-dim">
              {label}
            </div>
            <div
              className={`mt-0.5 text-sm font-semibold ${muted ? 'text-text-dim' : 'text-text'}`}
            >
              {value}
            </div>
          </div>
        ))}
      </div>
      {currentEntry?.name ? (
        <div className="mt-3 border-t border-border pt-3 text-xs text-text-muted">
          Current carrier:{' '}
          {currentEntry.carrier_id ? (
            <button
              type="button"
              onClick={() => openPeek(openCarrierPeek(currentEntry.carrier_id))}
              className="text-text hover:underline"
            >
              {currentEntry.name}
            </button>
          ) : (
            <span className="text-text">{currentEntry.name}</span>
          )}
        </div>
      ) : null}
    </section>
  );
}
